import React from "react";
import Left from "./nav/sections/left";
import Right from "./nav/sections/right";

const MainMenu: React.FC = () => {
	return (
		<>
			<div className="container mainMenuContainer">
				<ul className="nav navbar-nav mainNav">
					<Left />
				</ul>
				<Right />
			</div>
		</>
	);
};

export default MainMenu;
